import React, { Component } from 'react';
import { connect } from 'react-redux';
import GenericTable from 'screens/components/advanced/GenericTable';
import TextInput from 'screens/components/basic/TextInput';
import LOOKUP from 'constants/lookup';
import CardSimple from 'screens/components/basic/CardSimple';
import ImageUpload from 'screens/components/basic/ImageUpload';
import Button from 'screens/components/basic/Button';
import { convertDateToString } from 'utils/helpers';
import { createPrescription  } from 'actions/EntityActions';
import { clearFormInput } from 'actions/FormActions';

class patientTabPrescriptions extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            compName: "prescriptions"
        };
    }

    componentWillReceiveProps(newProps) {
        if(newProps.prescriptionId !== this.props.prescriptionId) {
            window.location.reload();
        }
    }

    mapPrescriptions(prescriptions) {
        if(prescriptions !== undefined && prescriptions !== null) {
            return prescriptions.map(prescription => {
                return {
                    CreatedDate: convertDateToString(prescription.createdDate),
                    Note: prescription.note,
                    Options: <Button
                                name="saveButton"
                                label={"Download"}
                                href={prescription.path}
                                target="_blank"
                                download={prescription.path}
                                primary={true} 
                             />
                }
            });
        }
        return null;
    }

    savePrescription = () => {
        this.props.createPrescription({
            patientId: this.props.patientId,
            note: this.props.note,
            branchId: this.props.branchId,
            path: this.props.path,
            next: (this.props.prescriptions.length + 1)
        });
    }

    render() {       

        return (
            <div className="prescription-content">
                <CardSimple>
                    
                    <div className="row">
                        <h3 className="title-form-prescription">Add new Prescription</h3>
                    </div>
                    
                    <div className="row form-prescription">
                        <div className="col-xs-12 col-sm-10 col-md-10 col-lg-10 col-xl-10">
                            <TextInput
                                name={this.state.compName + "Note"}
                                label="Note"
                                floatingLabelText="Note"
                                fullWidth={true}
                            />
                        </div>

                        <div className="col-xs-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 btn-upload">
                            <ImageUpload name={`${this.state.compName}Path`} />
                        </div>
                    </div>

                    <div className="row btn-save-prescription">
                        <div className="col-lg-12">
                            <Button name="buttonSave"
                                className="pull-right"
                                label="SAVE PRESCRIPTION"
                                primary={true}
                                onTouchTap={() => this.savePrescription()} />
                        </div>
                    </div>

                    <GenericTable
                        className="table_center"
                        multiSelectable={false}
                        enableSelectAll={false}
                        displaySelectAll={false}
                        adjustForCheckbox={false}
                        displayRowCheckbox={false}
                        selectable={false}
                        stripedRows={true}
                        columns={LOOKUP.menu.admin.prescriptionListTableColumns}
                        rows={this.mapPrescriptions(this.props.prescriptions)}
                    />
                        
                </CardSimple>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        branchId: state.common.branchId,
        note: state.form.prescriptionsNote,
        path: state.form.prescriptionsPath,
        prescriptionId: state.entity.prescriptionId
    };
}

function mapDispatchToProps(dispatch) {
    return {
        createPrescription: (model) => dispatch(createPrescription(model)),
        clearFormInput: (name) => dispatch(clearFormInput(name))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(patientTabPrescriptions);